import script from "./AssignUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignUserModal.vue?vue&type=script&setup=true&lang=js"

import "./AssignUserModal.vue?vue&type=style&index=0&id=e0421df0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0421df0"]])

export default __exports__